export default __webpack_public_path__ + "static/media/reactivity.657db3d6.jpg";